import { render, staticRenderFns } from "./MainHeaderPlatA.vue?vue&type=template&id=8c5036d6"
import script from "./MainHeaderPlatA.vue?vue&type=script&lang=js"
export * from "./MainHeaderPlatA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports